var UitkLoadingBarTypesMap = [
    ['determinate', 'determinate'],
    ['indeterminate', 'indeterminate']
];
var UitkLoadingBarTypes = new Map(UitkLoadingBarTypesMap);

export { UitkLoadingBarTypes };
